import React from "react";
import { Box, Typography } from "@material-ui/core";
import { css } from "@emotion/css";
import PollingImage from "shared/PollingImage";
import HtmlText from "./HtmlText";
import { PartFormData } from "../../types";
import { readLocale } from "../../utils";

type Props = { part: PartFormData | undefined; locale: string };

const LessonScreen: React.VFC<Props> = ({ part, locale }) => {
  if (!part) return <Box>No part</Box>;
  const title = readLocale(part.title, locale);
  const coverUrl = readLocale(part.imageUrl, locale);
  return (
    <Box className={styles.screen}>
      <Typography variant="h5" className={styles.title}>
        {title || "Untitled"}
      </Typography>
      {coverUrl && <PollingImage src={coverUrl} className={styles.cover} />}
      {(part.content ?? []).map((block, i) => {
        const val = readLocale(block.content, locale);
        if (block.type === "heading") {
          return <HtmlText key={i} html={val} className={styles.heading} component="h6" />;
        }
        if (block.type === "paragraph") {
          return <HtmlText key={i} html={val} className={styles.paragraph} />;
        }
        if (block.type === "image" && val) {
          return <PollingImage key={i} src={val} className={styles.inlineImage} />;
        }
        return null;
      })}
    </Box>
  );
};

export default React.memo(LessonScreen);

const styles = {
  screen: css`
    padding: 16px;
    overflow-y: auto;
    height: 100%;
  `,
  title: css`
    font-weight: 700;
    margin-bottom: 8px;
  `,
  cover: css`
    width: 100%;
    border-radius: 8px;
    margin-bottom: 12px;
  `,
  heading: css`
    font-weight: 700;
    margin-top: 12px;
  `,
  paragraph: css`
    margin-top: 6px;
    line-height: 1.5;
  `,
  inlineImage: css`
    width: 100%;
    border-radius: 6px;
    margin: 8px 0;
  `,
};
